function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.8929 14.6134H3.8929C3.15652 14.6134 2.55957 14.0164 2.55957 13.28V2.61336C2.55957 1.87698 3.15652 1.28003 3.8929 1.28003H8.55957C8.56684 1.28034 8.57402 1.28169 8.5809 1.28403C8.58742 1.28604 8.59412 1.28738 8.6009 1.28803C8.65969 1.2918 8.71774 1.30323 8.77357 1.32203L8.79224 1.32803C8.80735 1.33315 8.82205 1.33939 8.83624 1.3467C8.90887 1.37898 8.97505 1.42415 9.03157 1.48003L13.0316 5.48003C13.0874 5.53655 13.1326 5.60273 13.1649 5.67536C13.1716 5.69003 13.1762 5.70536 13.1816 5.7207L13.1876 5.73803C13.2062 5.79362 13.2172 5.85148 13.2202 5.91003C13.2213 5.91615 13.2228 5.92218 13.2249 5.92803C13.2261 5.93418 13.2265 5.94044 13.2263 5.9467V13.28C13.2263 14.0164 12.6293 14.6134 11.8929 14.6134ZM3.8929 2.61336V13.28H11.8929V6.61336H8.55957C8.19138 6.61336 7.8929 6.31489 7.8929 5.9467V2.61336H3.8929ZM9.22624 3.55603V5.28003H10.9502L9.22624 3.55603Z",
  fill: "#62768F"
});

function SvgReport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.ad76338a.svg";
export { ForwardRef as ReactComponent };